import { render, staticRenderFns } from "./ContactPersonDetails.vue?vue&type=template&id=063ce050&scoped=true"
import script from "./ContactPersonDetails.vue?vue&type=script&lang=js"
export * from "./ContactPersonDetails.vue?vue&type=script&lang=js"
import style0 from "./ContactPersonDetails.vue?vue&type=style&index=0&id=063ce050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063ce050",
  null
  
)

export default component.exports